export const colors = {
  A: '#E53935',
  B: '#D81B60',
  C: '#8E24AA',
  D: '#5E35B1',
  E: '#3949AB',
  F: '#1E88E5',
  G: '#039BE5',
  H: '#00ACC1',
  I: '#0BA898',
  J: '#008989',
  K: '#037855',
  L: '#00890E',
  M: '#43A047',
  N: '#7CB342',
  O: '#C0CA33',
  P: '#DAE730',
  Q: '#FFD600',
  R: '#FFB300',
  S: '#FB7800',
  T: '#F4511E',
  U: '#CF4747',
  V: '#8F4E4E',
  W: '#6D4C41',
  X: '#6C6D41',
  Y: '#757575',
  Z: '#546E7A',
};
